import React from 'react';
import { Box, Button, Icon } from '@chakra-ui/react';
import { FaMapMarkerAlt } from 'react-icons/fa';

const FacilityMap = ({ height = '500px' }) => {
  const handleGetDirections = () => {
    const address = encodeURIComponent('2200 Lucien Way, Suite 100, Maitland, FL 32751');
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${address}`, '_blank');
  };

  return (
    <Box
      w="100%"
      h={height}
      borderRadius="2xl"
      overflow="hidden"
      boxShadow="2xl"
      bg="white"
      position="relative"
    >
      <iframe
        src="https://www.google.com/maps?q=2200+Lucien+Way,+Suite+100,+Maitland,+FL+32751&output=embed"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Lake Lucien Surgery Center Location"
      />

      {/* Get Directions Button Overlay */}
      <Button
        position="absolute"
        bottom={6}
        right={6}
        bg="linear-gradient(135deg, #2196f3 0%, #00bcd4 100%)"
        color="white"
        size="lg"
        leftIcon={<Icon as={FaMapMarkerAlt} />}
        onClick={handleGetDirections}
        boxShadow="xl"
        _hover={{
          transform: 'translateY(-2px)',
          boxShadow: '2xl',
        }}
        _active={{
          transform: 'translateY(0)',
        }}
        transition="all 0.2s"
        fontWeight="700"
        zIndex={10}
      >
        Get Directions
      </Button>
    </Box>
  );
};

export default FacilityMap;
